import type { ReactElement } from "react";

// A shimmering placeholder block shown while a panel's data loads. Sized by
// the caller; stack a few to sketch the incoming layout.
export function Skeleton({
  width = "100%",
  height = "1rem",
}: {
  width?: string;
  height?: string;
}): ReactElement {
  return <span className="skeleton" style={{ width, height }} aria-hidden="true" />;
}

// The common "card of incoming rows" placeholder.
export function SkeletonRows({ rows = 3 }: { rows?: number }): ReactElement {
  return (
    <div role="status" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <p key={i}>
          <Skeleton width={`${100 - i * 12}%`} />
        </p>
      ))}
    </div>
  );
}
